import React from 'react';
import { Button, Header, Icon, Loader, Popup, Table } from 'semantic-ui-react';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import AddStudentPause from './AddStudentPause';
import { FiltersOnStyle, IconHeader } from '../../Professor/ProfessorInputGrades/css';
import moment from 'moment';
import InternshipForm from './InternshipForm';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

class StudentInternships extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dataActive: [],
            dataPast: [],

            newDate: new Date(),
            newDocumentNumber: '',
            newReason: '',
            newComment: '',
            newId: null,
            newOptLock: null,

            showAddForm: false,
            showEditForm: false,
            confirmation: false,
        };
        this.onRemoveInternship = this.onRemoveInternship.bind(this);
        this.getInternships = this.getInternships.bind(this);
    }

    componentDidMount() {
        this.getInternships();
    }

    getInternships() {
        this.setState({ loader: true });
        axios.get(`student-study-program-internship/${this.props.studentStudyProgramId}/`)
            .then(res => {
                const dataActive = res.data;
                this.setState({ dataActive, loader: false });
            })
            .catch(err => {
                console.log('Failed to fetch internships data.');
            });
    }

    onRemoveInternship(id) {
        this.setState({ loader: true });
        axios.delete(`student-study-program-internship/delete/${id}`)
            .then(res => {
                this.setState({ loader: false });
                this.getInternships();
            })
            .then(res => {
                toast('Informacije o praksi su uspješno izbrisane.');
            })
            .catch(err => {
                toast('Došlo je do greške. Brisanje podataka nije uspjelo.');
            });
        this.setState({ confirmation: false });
    }

    render() {
        return (
            <div>

                {this.state.showAddForm && <InternshipForm
                    studentStudyProgramId={this.props.studentStudyProgramId}
                    getInternships={() => this.getInternships()}
                    togglePauseVisibility={this.props.togglePauseVisibility}
                    closeForm={() => this.setState({ showAddForm: false })}
                />}
                {this.state.showEditForm && <InternshipForm
                    edit
                    studentStudyProgramId={this.props.studentStudyProgramId}
                    getInternships={() => this.getInternships()}
                    closeForm={() => this.setState({ showEditForm: false })}
                />}

                {
                    (!this.state.showAddForm && !this.state.showEditForm) && !this.props.locked &&
                    <div>

                        <Header style={IconHeader} floated="right" >
                            <Button
                                disabled={localStorage.getItem('activeRole') === 'AIDA' || localStorage.getItem('activeRole').substr(0, 19) === 'Prodekan za nastavu' || localStorage.getItem('activeRole').startsWith('Prodekan za međunarodnu')}
                                floated="right"
                                icon
                                labelPosition="right"
                                color="blue"
                                size="small"
                                style={FiltersOnStyle}
                                onClick={() => { this.setState({ showAddForm: true }); window.scrollTo(0, 0); }}
                            ><Icon className="add" />
                                Dodavanje prakse
                            </Button>
                        </Header>
                    </div>}
                <br />

                <div>

                    {/* <h3>Statusi mirovanja</h3> */}
                    <br />
                    {this.state.loader ? <div style={{ paddingTop: '50px' }}><Loader active inline="centered" /></div> :
                        this.state.dataActive.length ? <Table celled selectable compact >
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell>Naziv institucije</Table.HeaderCell>
                                    <Table.HeaderCell>Akademska godina</Table.HeaderCell>
                                    <Table.HeaderCell>Datum početka</Table.HeaderCell>
                                    <Table.HeaderCell>Datum kraja</Table.HeaderCell>
                                    <Table.HeaderCell>Trajanje</Table.HeaderCell>
                                    <Table.HeaderCell>Mentor</Table.HeaderCell>
                                    <Table.HeaderCell>Napomena</Table.HeaderCell>
                                    <Table.HeaderCell />
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                {this.state.dataActive.map((el, index) =>
                                    (<Table.Row key={index}>
                                        <Table.Cell verticalAlign="middle">
                                            {el.institutionName ? el.institutionName : ''}
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle">
                                            {el.academicYear ? el.academicYear.name : ''}
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle">
                                            {el.dateStart ? moment(el.dateStart).format('D. M. YYYY.') : ''}
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle">
                                            {el.dateEnd ? moment(el.dateEnd).format('D. M. YYYY.') : ''}
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle">
                                            {el.durationHours ? el.durationHours : ''}
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle">
                                            {el.mentor ? el.mentor : ''}
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle">
                                            {el.comment}
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle" textAlign="center">

                                            {/* <Popup */}

                                            {/*    content="Izmijeni" */}
                                            {/*    position="top center" */}
                                            {/*    trigger={ */}
                                            {/*        <Button */}
                                            {/*            disabled={(!this.props.pauseSemester && this.props.locked) || localStorage.getItem('activeRole') === 'AIDA' || localStorage.getItem('activeRole').substr(0, 19) === 'Prodekan za nastavu'} */}
                                            {/*            basic="true" */}
                                            {/*            circular */}
                                            {/*            icon="pencil" */}
                                            {/*            size="small" */}
                                            {/*            color="green" */}
                                            {/*            onClick={() => { */}
                                            {/*                localStorage.setItem('studentInternshipObject', JSON.stringify(el)); */}
                                            {/*                this.setState({ showEditForm: true, studentInternshipObject: el }); */}
                                            {/*                window.scrollTo(0, 0); */}
                                            {/*            }} */}
                                            {/*        > */}
                                            {/*        </Button>} */}
                                            {/* /> */}

                                            {this.state.confirmation === index ?
                                                <div>
                                                    <h4>Jeste li sigurni?</h4>
                                                    <Button.Group compact fluid>
                                                        <Button
                                                            basic="true"
                                                            color="blue"
                                                            onClick={() => this.onRemoveInternship(el.id)}
                                                        > DA</Button>
                                                        <Button
                                                            basic="true"
                                                            color="red"
                                                            onClick={() => { this.setState({ confirmation: false }); }}
                                                        >  NE
                                                        </Button>
                                                    </Button.Group>
                                                </div>
                                                : <div>

                                                    <Popup

                                                        content="Izmijeni"
                                                        position="top center"
                                                        trigger={
                                                            <Button
                                                                disabled={(!this.props.pauseSemester && this.props.locked) || localStorage.getItem('activeRole') === 'AIDA' || localStorage.getItem('activeRole').substr(0, 19) === 'Prodekan za nastavu' || localStorage.getItem('activeRole').startsWith('Prodekan za međunarodnu')}
                                                                basic="true"
                                                                circular
                                                                icon="pencil"
                                                                size="small"
                                                                color="green"
                                                                onClick={() => {
                                                                    localStorage.setItem('studentInternshipObject', JSON.stringify(el));
                                                                    this.setState({ showEditForm: true, studentInternshipObject: el });
                                                                    window.scrollTo(0, 0);
                                                                }}
                                                            >
                                                            </Button>}
                                                    />
                                                    <Popup
                                                        content="Obriši"
                                                        position="top center"
                                                        trigger={
                                                            <Button
                                                                disabled={(!this.props.pauseSemester && this.props.locked) || localStorage.getItem('activeRole') === 'AIDA' || localStorage.getItem('activeRole').substr(0, 19) === 'Prodekan za nastavu' || localStorage.getItem('activeRole').startsWith('Prodekan za međunarodnu')}
                                                                basic="true"
                                                                circular
                                                                icon="trash alternate"
                                                                size="small"
                                                                color="red"
                                                                onClick={() => { this.setState({ confirmation: index }); }}
                                                                // onClick={() => this.onRemoveInternship(el.id)}
                                                            />}
                                                    /></div>}
                                        </Table.Cell>
                                    </Table.Row>))}
                            </Table.Body>
                        </Table>

                            : <div> Nema podataka o praksama.</div>
                    }

                </div>

                <ToastContainer hideProgressBar />
            </div>
        );
    }
}

export default StudentInternships;



// WEBPACK FOOTER //
// ./src/views/StudentService/StudentOverview/StudentInternships.js